module.exports = __webpack_public_path__ + "img/CPQ-ability-01.56732456.png";